module.exports = __webpack_public_path__ + "img/ic_shui_fa.621095bd.png";